import { cn } from '../lib/cn'
import { useUiStrings } from '../i18n'
import { Container } from './primitives'
import { Logo } from './SiteHeader'

export type FooterLink = { label: string; href: string }

/**
 * Schlanke Fußzeile.
 *
 * Im Entwurf ist keine Fußzeile vorgesehen – Impressum und
 * Datenschutzerklärung sind für eine gewerbliche Website in Deutschland
 * aber Pflicht, deshalb hier als dezente Zeile ergänzt. Die Ziele lassen
 * sich über `links` austauschen.
 */
export function SiteFooter({
  links,
  note,
  className,
}: {
  links: FooterLink[]
  note?: string
  className?: string
}) {
  const t = useUiStrings();

  return (
    <footer className={cn('border-t border-white/10 py-10', className)}>
      <Container className="flex flex-col items-center gap-6 sm:flex-row sm:justify-between">
        <Logo className="h-7 opacity-90" />

        <nav aria-label={t.legal}>
          <ul className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm text-white/80">
            {links.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  rel="noopener noreferrer"
                  className="transition-colors hover:text-white"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>

        {note && <p className="text-xs text-white/60">{note}</p>}
      </Container>
    </footer>
  )
}
